(function () {
  var configEl = document.getElementById('FindAFrameConfig');
  var form = document.getElementById('FindAFrameForm');
  if (!configEl || !form) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var emailEl = document.getElementById('FafEmail');
  if (!emailEl) return;
  form.noValidate = true;

  var messages = config.messages || {};
  var root = config.root || '/';
  if (root.slice(-1) !== '/') root += '/';

  var endpoint = (config.endpoint || '').trim().replace(/\/+$/, '');
  if (!/^https?:\/\//i.test(endpoint)) endpoint = '';

  var search = document.getElementById('FafSearch');
  var results = document.getElementById('FafResults');
  var chip = document.getElementById('FafChip');
  var chipImg = null;
  var chipTitle = document.getElementById('FafChipTitle');
  var frameValue = document.getElementById('FafFrameValue');
  var changeValue = document.getElementById('FafChangeValue');
  var clientError = document.getElementById('FafClientError');
  var honeypot = document.getElementById('FafHp');
  var bodyEl = document.getElementById('FafBody');
  var otherLink = document.getElementById('FafOtherLink');
  var fileInput = document.getElementById('FafFiles');
  var drop = document.getElementById('FafDrop');
  var thumbs = document.getElementById('FafThumbs');
  var fileError = document.getElementById('FafFileErr');
  var uploadValue = document.getElementById('FafUploadValue');

  var MAX_FILES = 4;
  var MAX_BYTES = 10 * 1024 * 1024;
  var TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var files = [];
  var pending = 0;
  var claimed = false;
  var searchTimer;
  var searchRequest = 0;
  var choices = document.getElementById('FafChoices');

  function selectedChoice() {
    var checked = form.querySelector('.faf__card-input:checked');
    return checked ? checked.getAttribute('data-choice') : '';
  }

  function setDisabled(el, disabled) {
    if (el && el.disabled !== disabled) el.disabled = disabled;
  }

  function choiceFilled(choice) {
    if (choice === 'shop') {
      return !!(frameValue && frameValue.value.trim()) || !!form.querySelector('.faf-change:checked');
    }
    if (choice === 'link') {
      return !!(otherLink && otherLink.value.trim());
    }
    if (choice === 'photo') {
      return files.length > 0;
    }
    return false;
  }

  function applyChoice() {
    var choice = selectedChoice();
    form.querySelectorAll('[data-choice-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-choice-panel') === choice;
      panel.hidden = !on;
      panel.querySelectorAll('input, select, textarea, button').forEach(function (el) {
        setDisabled(el, !on);
      });
    });
    setDisabled(frameValue, choice !== 'shop');
    setDisabled(changeValue, choice !== 'shop');
    if (changeValue) {
      changeValue.value =
        choice === 'shop'
          ? Array.prototype.map
              .call(form.querySelectorAll('.faf-change:checked'), function (box) {
                return box.value;
              })
              .join(', ')
          : '';
    }
    if (choice === 'photo') syncUploads();
    else if (uploadValue) uploadValue.value = '';
    setDisabled(uploadValue, choice !== 'photo');
  }

  function commitChoice(choice) {
    applyChoice();
    if (choice !== 'shop') {
      if (frameValue) frameValue.value = '';
      if (changeValue) changeValue.value = '';
    }
    if (choice !== 'link' && otherLink) otherLink.value = '';
    if (choice !== 'photo' && uploadValue) uploadValue.value = '';
  }

  function showClientError(message) {
    clientError.textContent = message;
    clientError.hidden = false;
    clientError.focus();
    if (typeof clientError.scrollIntoView === 'function') {
      clientError.scrollIntoView({ block: 'center' });
    }
  }

  function showFileError(message) {
    fileError.textContent = message || '';
    fileError.hidden = !message;
  }

  function syncUploads() {
    uploadValue.value = files
      .filter(function (entry) {
        return entry.url;
      })
      .map(function (entry) {
        return entry.url;
      })
      .join('\n');
  }

  function sizedImage(url) {
    if (!url) return '';
    var absolute = url.indexOf('//') === 0 ? 'https:' + url : url;
    return absolute + (absolute.indexOf('?') === -1 ? '?' : '&') + 'width=192';
  }

  function absoluteProductUrl(url) {
    var path = (url || '').split('?')[0];
    if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) return path;
    if (path.charAt(0) !== '/') path = '/' + path;
    return location.origin + path;
  }

  function pick(item) {
    frameValue.value = item.title + ' | ' + absoluteProductUrl(item.url);
    if (!chipImg) {
      chipImg = document.createElement('img');
      chipImg.width = 96;
      chipImg.height = 64;
      chip.insertBefore(chipImg, chip.firstChild);
    }
    if (item.image) chipImg.src = item.image;
    else chipImg.removeAttribute('src');
    chipImg.alt = item.title || '';
    chipTitle.textContent = item.title || '';
    chip.hidden = false;
    search.hidden = true;
    results.replaceChildren();
    releaseChoiceError();
  }

  function renderResults(items) {
    results.replaceChildren();
    items.forEach(function (product) {
      var item = document.createElement('li');
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('role', 'option');
      var imageUrl = sizedImage(product.image);
      if (imageUrl) {
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.width = 56;
        image.height = 56;
        button.appendChild(image);
      }
      var label = document.createElement('span');
      label.textContent = product.title || '';
      button.appendChild(label);
      button.addEventListener('click', function () {
        pick({ title: product.title, url: product.url, image: imageUrl });
      });
      item.appendChild(button);
      results.appendChild(item);
    });
  }

  if (search && results && chip) {
    search.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var query = search.value.trim();
      if (query.length < 2) {
        results.replaceChildren();
        return;
      }
      searchTimer = setTimeout(function () {
        var requestId = ++searchRequest;
        fetch(
          root +
            'search/suggest.json?q=' +
            encodeURIComponent(query) +
            '&resources[type]=product&resources[limit]=6'
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (requestId !== searchRequest) return;
            var products = ((data.resources || {}).results || {}).products || [];
            renderResults(products);
          })
          .catch(function () {});
      }, 250);
    });

    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') results.replaceChildren();
    });

    document.addEventListener('click', function (event) {
      if (!search.contains(event.target) && !results.contains(event.target)) {
        results.replaceChildren();
      }
    });

    document.getElementById('FafChipClear').addEventListener('click', function () {
      frameValue.value = '';
      chip.hidden = true;
      search.hidden = false;
      search.value = '';
      search.focus();
    });

    var handle = new URLSearchParams(location.search).get('frame');
    if (handle && /^[a-z0-9_-]+$/.test(handle)) {
      var shopRadio = document.getElementById('FafChoiceShop');
      if (shopRadio) shopRadio.checked = true;
      fetch(root + 'products/' + handle + '.js')
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          pick({
            title: product.title,
            url: root.replace(/\/$/, '') + '/products/' + product.handle,
            image: sizedImage(product.featured_image),
          });
        })
        .catch(function () {});
    }
  }

  function drawThumbs() {
    thumbs.replaceChildren();
    files.forEach(function (entry, index) {
      var item = document.createElement('li');
      if (entry.busy) item.className = 'is-busy';
      if (entry.failed) item.className = 'is-failed';
      var image = document.createElement('img');
      image.src = entry.preview;
      image.alt = entry.file.name;
      item.appendChild(image);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = messages.remove || 'Remove';
      remove.setAttribute('aria-label', (messages.remove || 'Remove') + ' ' + entry.file.name);
      remove.addEventListener('click', function () {
        URL.revokeObjectURL(entry.preview);
        files.splice(index, 1);
        syncUploads();
        drawThumbs();
        if (
          !files.some(function (candidate) {
            return candidate.failed;
          })
        ) {
          showFileError('');
        }
      });
      item.appendChild(remove);
      thumbs.appendChild(item);
    });
  }

  function upload(entry) {
    if (!endpoint || (honeypot && honeypot.value)) return;
    entry.busy = true;
    pending += 1;
    var body = new FormData();
    body.append('file', entry.file);
    body.append('website', '');
    fetch(endpoint, { method: 'POST', body: body })
      .then(function (response) {
        if (!response.ok) throw new Error('upload');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.id || !data.url) throw new Error('upload');
        entry.id = data.id;
        entry.url = data.url;
        entry.failed = false;
      })
      .catch(function () {
        if (files.indexOf(entry) === -1) return;
        entry.failed = true;
        entry.id = '';
        entry.url = '';
        showFileError(messages.failed || '');
      })
      .then(function () {
        entry.busy = false;
        pending = Math.max(0, pending - 1);
        syncUploads();
        drawThumbs();
      });
  }

  function fileKey(file) {
    return [file.name, file.size, file.lastModified].join(':');
  }

  function addFiles(list) {
    showFileError('');
    Array.prototype.forEach.call(list, function (file) {
      var key = fileKey(file);
      if (
        files.some(function (entry) {
          return fileKey(entry.file) === key;
        })
      ) {
        return;
      }
      if (files.length >= MAX_FILES) {
        showFileError(messages.tooMany || '');
        return;
      }
      var type = file.type || '';
      if (TYPES.indexOf(type) === -1) {
        showFileError(messages.badType || '');
        return;
      }
      if (file.size > MAX_BYTES) {
        showFileError(messages.tooBig || '');
        return;
      }
      var entry = { file: file, preview: URL.createObjectURL(file), url: '', id: '', busy: false, failed: false };
      files.push(entry);
      upload(entry);
    });
    drawThumbs();
    fileInput.value = '';
    releaseChoiceError();
  }

  if (fileInput && drop) {
    fileInput.addEventListener('change', function () {
      addFiles(fileInput.files);
    });
    ['dragenter', 'dragover'].forEach(function (name) {
      drop.addEventListener(name, function (event) {
        event.preventDefault();
        drop.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function (name) {
      drop.addEventListener(name, function (event) {
        event.preventDefault();
        drop.classList.remove('is-over');
      });
    });
    drop.addEventListener('drop', function (event) {
      if (event.dataTransfer) addFiles(event.dataTransfer.files);
    });
  }

  function clearChoiceInvalid() {
    form.querySelectorAll('.faf__card.is-invalid').forEach(function (card) {
      card.classList.remove('is-invalid');
    });
  }

  function markChoiceInvalid() {
    clearChoiceInvalid();
    var checked = form.querySelector('.faf__card-input:checked');
    var card = checked && checked.closest('.faf__card');
    if (card) card.classList.add('is-invalid');
  }

  function releaseChoiceError() {
    if (!form.querySelector('.faf__card.is-invalid')) return;
    var choice = selectedChoice();
    var described = !!(bodyEl && bodyEl.value.trim());
    if (described || (choice && choiceFilled(choice))) {
      clearChoiceInvalid();
      if (choices) choices.removeAttribute('aria-invalid');
      if (clientError) clientError.hidden = true;
    }
  }

  form.querySelectorAll('.faf__card-input').forEach(function (radio) {
    radio.addEventListener('change', function () {
      clearChoiceInvalid();
      if (choices && choices.getAttribute('aria-invalid') === 'true') {
        clientError.hidden = true;
        choices.removeAttribute('aria-invalid');
      }
      applyChoice();
    });
  });
  form.addEventListener('input', releaseChoiceError);
  form.addEventListener('change', releaseChoiceError);
  applyChoice();

  form.addEventListener('submit', function (event) {
    clientError.hidden = true;
    emailEl.removeAttribute('aria-invalid');
    if (choices) choices.removeAttribute('aria-invalid');
    clearChoiceInvalid();
    if (honeypot && honeypot.value) {
      event.preventDefault();
      return;
    }
    if (pending > 0) {
      event.preventDefault();
      showClientError(messages.wait || '');
      return;
    }

    var choice = selectedChoice();
    var email = emailEl.value.trim();
    var described = !!(bodyEl && bodyEl.value.trim());
    var message = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      message = messages.email || '';
      emailEl.setAttribute('aria-invalid', 'true');
    } else if (!choice) {
      message = messages.choice || '';
      if (choices) choices.setAttribute('aria-invalid', 'true');
    } else if (!described && !choiceFilled(choice)) {
      message = messages.choiceEmpty || '';
      if (choices) choices.setAttribute('aria-invalid', 'true');
      markChoiceInvalid();
    }
    if (message) {
      event.preventDefault();
      showClientError(message);
      return;
    }

    commitChoice(choice);

    var ids =
      choice === 'photo'
        ? files
            .filter(function (entry) {
              return entry.id;
            })
            .map(function (entry) {
              return entry.id;
            })
        : [];
    if (!claimed && endpoint && ids.length && navigator.sendBeacon) {
      claimed = true;
      // JSON body. text/plain keeps this a simple cross-origin POST, so the
      // beacon still leaves with the native contact-form navigation.
      navigator.sendBeacon(
        endpoint + '/claim',
        new Blob([JSON.stringify({ ids: ids })], { type: 'text/plain' })
      );
    }
  });
})();
